import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { persistStore } from 'redux-persist';
import { ReduxRouter } from '@lagunovsky/redux-react-router'

import createStore, { sagas } from './store'
import { sagaMiddleware } from './store/middleware'

import { Router } from './config/router'
import interceptor from './config/interceptor'
import { browserHistory } from './config/router/history'

import reportWebVitals from './reportWebVitals'

import './index.css'

// silencia log/info/debug en prod. error/warn se mantienen.
/* eslint-disable no-console */
if (process.env.NODE_ENV === 'production') {
  const noop = () => {}
  console.log = noop
  console.info = noop
  console.debug = noop
}
/* eslint-enable no-console */

if (
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_CLEAR_SESSION_ON_START === 'true' &&
  typeof window !== 'undefined'
) {
  window.sessionStorage.removeItem('persist:root')
  window.sessionStorage.removeItem('token')
  window.sessionStorage.removeItem('refreshToken')
  window.sessionStorage.removeItem('accessTokenExpiresAtUtc')
  window.sessionStorage.removeItem('refreshTokenExpiresAtUtc')
  window.sessionStorage.removeItem('sessionExpiresAtUtc')
  window.sessionStorage.removeItem('login')
  window.sessionStorage.removeItem('pinChallenge')
}

const store = createStore()
sagaMiddleware.run(sagas)
interceptor.run(store)
export const persistor = persistStore(store)

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <ReduxRouter history={browserHistory} store={store}>
        <Router />
      </ReduxRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
